
  (() => {
    const normalizeMediaKey = (value) => {
      const normalized = String(value || '').toLowerCase();
      if (normalized.includes('light oak') || normalized.includes('oak')) return 'light-oak';
      if (normalized.includes('frameless')) return 'frameless';
      if (normalized.includes('black')) return 'black';
      if (normalized.includes('white')) return 'white';
      return 'artwork';
    };

    const initializeProduct = (root) => {
      if (root.dataset.productBound === 'true') return;
      root.dataset.productBound = 'true';

      const variantsNode = root.querySelector('[data-product-variants]');
      if (!variantsNode) return;
      const variants = JSON.parse(variantsNode.textContent);
      const groups = [...root.querySelectorAll('[data-option-group]')];
      const mediaItems = [...root.querySelectorAll('[data-product-media]')];
      const mediaTabs = [...root.querySelectorAll('[data-media-tab]')];
      const variantInput = root.querySelector('[data-product-variant-id]');
      const price = root.querySelector('[data-product-price]');
      const priceOptions = root.querySelector('[data-product-price-options]');
      const selection = root.querySelector('[data-product-selection]');
      const includes = root.querySelector('[data-product-includes]');
      const addButton = root.querySelector('[data-product-add]');
      const addText = root.querySelector('[data-product-add-text]');
      const mediaStatus = root.querySelector('[data-media-status]');
      const quantity = root.querySelector('[data-product-quantity]');
      const sticky = root.querySelector('[data-product-sticky]');
      const stickySelection = root.querySelector('[data-sticky-selection]');
      const stickyChoose = root.querySelector('[data-sticky-choose]');
      const stickyChooseCopy = root.querySelector('[data-sticky-choose-copy]');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      const stickyAddText = root.querySelector('[data-sticky-add-text]');
      const stagePrice = root.querySelector('[data-product-stage-price]');
      const productOptions = root.querySelector('[data-product-options]');
      const arrivalChoose = root.querySelector('[data-arrival-choose]');
      let selected;
      try {
        selected = JSON.parse(root.dataset.selectedOptions || '[]');
      } catch {
        selected = [];
      }
      if (!Array.isArray(selected) || selected.length === 0) {
        selected = variants[0]?.options.map(() => '') || [];
      }
      groups.forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        const pressed = group.querySelector('[data-option-value][aria-pressed="true"]');
        if (pressed) selected[index] = pressed.dataset.optionValue;
      });
      const finishGroup = groups.find((group) => group.hasAttribute('data-finish-group'));
      const sizeGroup = groups.find((group) => group.hasAttribute('data-size-group'));
      const finishIndex = finishGroup ? Number(finishGroup.dataset.optionIndex) : selected.length - 1;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' });

      const setActiveMedia = (media) => {
        if (!media) return;
        mediaItems.forEach((item) => {
          const active = item === media;
          if (!active) {
            const livingArt = item.querySelector('[data-dap-living-art]');
            if (livingArt) livingArt.dispatchEvent(new CustomEvent('dap:living-art:reset', { bubbles: true }));
          }
          item.classList.toggle('is-active', active);
          item.hidden = !active;
          item.setAttribute('aria-hidden', String(!active));
          item.toggleAttribute('inert', !active);
        });
        mediaTabs.forEach((tab) => {
          const active = tab.dataset.mediaTarget === media.id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });
        if (mediaStatus) {
          const template = mediaStatus.dataset.statusTemplate;
          mediaStatus.textContent = template
            .replace('[label]', media.dataset.mediaLabel)
            .replace('[index]', media.dataset.mediaIndex)
            .replace('[count]', String(mediaItems.length));
        }
      };

      const setMediaForFinish = (finish) => {
        const key = normalizeMediaKey(finish);
        const match = mediaItems.find((item) => item.dataset.mediaKey === key)
          || mediaItems.find((item) => item.dataset.mediaKey === 'artwork');
        if (match) setActiveMedia(match);
      };

      const findVariant = (options) => variants.find((variant) => variant.options.every((option, index) => option === options[index]));

      const updateOptionAvailability = () => {
        groups.forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const candidate = [...selected];
            candidate[index] = button.dataset.optionValue;
            const available = variants.some((variant) => variant.available && variant.options.every((option, optionIndex) => {
              if (optionIndex === index) return option === candidate[optionIndex];
              if (group === sizeGroup && optionIndex === finishIndex) return true;
              return option === selected[optionIndex];
            }));
            button.disabled = !available;
          });
        });
      };

      const updateFinishPrices = () => {
        if (!finishGroup) return;
        const baseOptions = [...selected];
        const baseButton = [...finishGroup.querySelectorAll('[data-option-value]')].find((button) => normalizeMediaKey(button.dataset.optionValue) === 'frameless');
        let baseVariant = null;
        if (baseButton) {
          baseOptions[finishIndex] = baseButton.dataset.optionValue;
          baseVariant = findVariant(baseOptions);
        }
        finishGroup.querySelectorAll('[data-option-value]').forEach((button) => {
          const label = button.querySelector('[data-option-price]');
          if (!label) return;
          const candidate = [...selected];
          candidate[finishIndex] = button.dataset.optionValue;
          const variant = findVariant(candidate);
          if (!variant) {
            label.textContent = '';
            return;
          }
          if (normalizeMediaKey(button.dataset.optionValue) === 'frameless') {
            label.textContent = variant.formattedPrice;
            return;
          }
          const delta = baseVariant ? Math.max(variant.price - baseVariant.price, 0) : 0;
          label.textContent = delta > 0 ? `+${formatter.format(delta / 100)}` : variant.formattedPrice;
        });
      };

      const updateVariant = ({ updateMedia = true } = {}) => {
        groups.forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          group.querySelectorAll('[data-option-value]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.optionValue === selected[index])));
          const current = group.querySelector('[data-option-current]');
          if (current) current.textContent = selected[index];
        });

        const variant = findVariant(selected);
        updateOptionAvailability();
        updateFinishPrices();
        root.querySelectorAll('[data-guide-size]').forEach(button => {
          const option = [...root.querySelectorAll('[data-size-group] [data-option-value]')].find(value => value.dataset.optionValue === button.dataset.guideSize);
          button.disabled = !option || option.disabled;
          button.setAttribute('aria-pressed', String(option?.getAttribute('aria-pressed') === 'true'));
        });
        if (!variant) return;

        root.classList.add('is-variant-changing');
        window.setTimeout(() => root.classList.remove('is-variant-changing'), 220);
        variantInput.value = variant.id;
        price.textContent = variant.formattedPrice;
        if (stagePrice) stagePrice.textContent = variant.formattedPrice;
        const dimensions = root.querySelector('[data-product-dimensions]');
        if (dimensions && sizeGroup) dimensions.textContent = variant.options[Number(sizeGroup.dataset.optionIndex)];
        const optionsText = variant.options.join(' · ');
        if (priceOptions) priceOptions.textContent = optionsText;
        selection.textContent = selection.dataset.selectionTemplate.replace('[options]', optionsText).replace('[price]', variant.formattedPrice);
        const finish = selected[finishIndex] || '';
        includes.textContent = normalizeMediaKey(finish) === 'frameless' ? includes.dataset.framelessLabel : includes.dataset.framedLabel;
        addButton.disabled = !variant.available;
        addText.textContent = variant.available ? addButton.dataset.addTemplate.replace('[price]', variant.formattedPrice) : addButton.dataset.soldOutLabel;
        if (stickySelection) stickySelection.textContent = optionsText;
        if (stickyAdd) stickyAdd.disabled = !variant.available;
        if (stickyAddText && stickyAdd) stickyAddText.textContent = variant.available ? stickyAdd.dataset.addTemplate.replace('[price]', variant.formattedPrice) : stickyAdd.dataset.soldOutLabel;
        if (updateMedia) setMediaForFinish(finish);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      groups.forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            const previousFinish = selected[finishIndex];
            selected[index] = button.dataset.optionValue;
            if (group === sizeGroup && !findVariant(selected)) {
              const matchingVariant = variants.find((variant) => variant.available
                && variant.options[index] === selected[index]
                && normalizeMediaKey(variant.options[finishIndex]) === 'frameless'
                && variant.options.every((option, optionIndex) => optionIndex === index || optionIndex === finishIndex || option === selected[optionIndex]));
              if (matchingVariant) selected[finishIndex] = matchingVariant.options[finishIndex];
            }
            updateVariant({ updateMedia: index === finishIndex || selected[finishIndex] !== previousFinish });
          });
        });
      });

      mediaTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => setActiveMedia(mediaItems.find((item) => item.id === tab.dataset.mediaTarget)));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = mediaTabs.length - 1;
          if (event.key === 'ArrowRight') next = (index + 1) % mediaTabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + mediaTabs.length) % mediaTabs.length;
          mediaTabs[next].focus();
          mediaTabs[next].click();
        });
      });

      root.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const next = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.quantityChange));
          quantity.value = String(next);
        });
      });

      root.querySelectorAll('[data-product-choose]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (!productOptions) return;
          event.preventDefault();
          const headerBottom = Math.max(0, document.querySelector('.dap-header')?.getBoundingClientRect().bottom || 0);
          productOptions.style.scrollMarginTop = `${Math.max(128, headerBottom + 16)}px`;
          const focusTarget = productOptions.querySelector('[data-size-group] [data-option-value][aria-pressed="true"]:not(:disabled)')
            || productOptions.querySelector('[data-option-value]:not(:disabled)')
            || productOptions;
          focusTarget.focus({ preventScroll: true });
          productOptions.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });

      if (sticky) {
        const compactPurchase = window.matchMedia('(max-width: 600px)');
        const productHeading = root.querySelector('.dap-product-heading h1');
        const syncSticky = () => {
          const rootRect = root.getBoundingClientRect();
          const addRect = addButton.getBoundingClientRect();
          const headingRect = productHeading ? productHeading.getBoundingClientRect() : null;
          const arrivalRect = arrivalChoose ? arrivalChoose.getBoundingClientRect() : null;
          const headerBottom = Math.max(0, document.querySelector('.dap-header')?.getBoundingClientRect().bottom || 0);
          const rootVisible = rootRect.top < window.innerHeight && rootRect.bottom > 0;
          const primaryAddVisible = addRect.top < window.innerHeight && addRect.bottom > 0;
          const arrivalChooseVisible = arrivalRect && arrivalRect.top < window.innerHeight && arrivalRect.bottom > headerBottom;
          const hasPassedPrimaryAdd = addRect.bottom <= 0;
          const headingClearsStickyBar = !headingRect || headingRect.bottom <= window.innerHeight - 104;
          sticky.dataset.stickyMode = hasPassedPrimaryAdd ? 'add' : 'choose';
          if (stickyChoose) stickyChoose.hidden = hasPassedPrimaryAdd;
          if (stickyChooseCopy) stickyChooseCopy.hidden = hasPassedPrimaryAdd;
          if (stickyAdd) stickyAdd.hidden = !hasPassedPrimaryAdd;
          if (stickySelection) stickySelection.hidden = !hasPassedPrimaryAdd;
          sticky.hidden = !compactPurchase.matches || !rootVisible || primaryAddVisible || arrivalChooseVisible || !headingClearsStickyBar;
        };
        const stickyObserver = new IntersectionObserver(syncSticky, { threshold: [0, 1] });
        stickyObserver.observe(root);
        stickyObserver.observe(addButton);
        if (arrivalChoose) stickyObserver.observe(arrivalChoose);
        compactPurchase.addEventListener?.('change', syncSticky);
        window.addEventListener('scroll', syncSticky, { passive: true });
        window.addEventListener('resize', syncSticky);
        syncSticky();
      }

      updateVariant({ updateMedia: true });
    };

    document.querySelectorAll('[data-dap-product-root]').forEach(initializeProduct);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-dap-product-root]').forEach(initializeProduct));
  })();
